import { AuthLayout } from "@-/dev.improve.haniverse.routes.nav.app.auth";

// Keep the welcome gate (`index`) under pushed auth forms so a `router.push` from the gate's
// account actions lands on sign-in/sign-up instead of replacing the only stack entry.
export const unstable_settings = {
  anchor: "index",
};

export default function AuthLayoutRoute() {
  return <AuthLayout />;
}
